<template>
  <div class="document">
    <h1>Politique de Confidentialité</h1>
    <p class="date">Dernière mise à jour : Août 2026</p>

    <section>
      <h2>1. Introduction</h2>
      <p>Nous attachons une grande importance à la protection de vos données personnelles. Cette Politique de Confidentialité explique comment nous collectons, utilisons, conservons et protégez vos données lorsque vous utilisez le portail du GUC Voile.</p>
    </section>

    <section>
      <h2>2. Responsable du Traitement</h2>
      <p>Responsable de Protection des Données (DPO) / Support : gucvoile@gmail.com</p>
    </section>

    <section>
      <h2>3. Données Personnelles Collectées</h2>
      <p>Nous collectons uniquement les données nécessaires au fonctionnement du portail :</p>
      <ul>
        <li>Informations de compte : nom, prénom, date de naissance, genre, numéro de téléphone, adresse email, mot de passe (chiffré)</li>
        <li>Données d'utilisation : informations relatives aux permanences, adhésion, covoiturages et matériels utilisés</li>
      </ul>
    </section>

    <section>
      <h2>4. Base Légale du Traitement</h2>
      <p>Le traitement de vos données s'effectue sur les bases légales suivantes :</p>
      <ul>
        <li>Intérêt légitime</li>
        <li>Consentement explicite</li>
        <li>Obligations légales et réglementaires</li>
      </ul>
    </section>

    <section>
      <h2>5. Partage des Données</h2>
      <p>Nous ne partageons pas vos données personnelles avec des tiers externes. Vos données ne sont accessibles que par :</p>
      <ul>
        <li>Notre équipe technique (pour la maintenance et le support)</li>
        <li>Nos prestataires d'hébergement (sous accord de confidentialité)</li>
      </ul>
    </section>

    <section>
      <h2>6. Durée de Conservation des Données</h2>
      <p>Nous conservons vos données personnelles aussi longtemps que votre compte est actif. Lors de la suppression de votre compte :</p>
      <ul>
        <li>Toutes vos données sont supprimées de nos serveurs de façon permanente</li>
        <li>Aucune sauvegarde n'est conservée</li>
        <li>La suppression est effective dans un délai de 30 jours</li>
      </ul>
    </section>

    <section>
      <h2>7. Vos Droits (RGPD)</h2>
      <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</p>
      <ul>
        <li>Droit d'accès : obtenir une copie de vos données</li>
        <li>Droit de rectification : corriger des données inexactes</li>
        <li>Droit à l'oubli : demander la suppression de vos données</li>
        <li>Droit à la portabilité : recevoir vos données dans un format exploitable</li>
        <li>Droit d'opposition : vous opposer au traitement de vos données</li>
      </ul>
    </section>

    <section>
      <h2>8. Sécurité des Données</h2>
      <p>Nous mettons en place les mesures de sécurité suivantes :</p>
      <ul>
        <li>Chiffrement des mots de passe</li>
        <li>Connexion HTTPS pour toutes les communications</li>
        <li>Stockage sécurisé des données sur serveurs protégés</li>
        <li>Accès restreint aux données</li>
      </ul>
    </section>

    <section>
      <h2>9. Cookies et Suivi</h2>
      <p>Notre Application n'utilise pas de cookies de suivi ni d'outils d'analytique tiers. Aucun suivi comportemental n'est effectué.</p>
    </section>

    <section>
      <h2>10. Modifications de cette Politique</h2>
      <p>Nous nous réservons le droit de modifier cette Politique de Confidentialité à tout moment. Les modifications seront notifiées via le portail ou par email. Votre continuation d'utilisation de l'Application implique l'acceptation de la version mise à jour.</p>
    </section>

    <section>
      <h2>11. Nous Contacter</h2>
      <p>Pour toute question concernant cette Politique de Confidentialité ou vos données personnelles : gucvoile@gmail.com</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PolitiqueConfidentialite'
}
</script>

<style scoped>
.document {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

h1 {
  font-size: 28px;
  margin-bottom: 10px;
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
}

.date {
  color: #666;
  font-style: italic;
  margin-bottom: 30px;
  display: block;
}

section {
  margin-bottom: 25px;
}

h2 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

p {
  margin-bottom: 10px;
}

ul {
  margin-left: 20px;
  margin-bottom: 10px;
}

li {
  margin-bottom: 8px;
}
</style>